import { Component, OnInit } from '@angular/core';
import { CadastroService } from '../servicos/cadastro.service';
import { PopupAlertService } from '../componentes/popup-alert.service';

@Component({
  selector: 'sessao-formulario',
  templateUrl: './sessao-formulario.component.html',
  styleUrls: ['./sessao-formulario.component.scss']
})
export class SessaoFormularioComponent implements OnInit {

  public formulario: any = {motivo: "CONTATO NO SITE DA DETALHEINFO, PARA DESENVOLVIMENTO DE SOFTWARE", nome:"", tipo:1, telefone:"", urgencia:1, investimento: 1};
  public tipoList: any = [{id:1, text:"APLICATIVO WEB"},{id:2, text:"APLICATIVO DESKTOP"}, {id:3, text:"APLICATIVO MOBILE"} ,{id:4, text:"SITE"}];
  public urgenciaList: any = [{id:1, text:"POUCO URGENTE"},{id:2, text:"URGENTE"},{id:3, text:"MUITO URGENTE"} ];
  public investimentoList: any = [{id:1, text:"Até R$6.000,00"},{id:2, text:"De 6.000,00 a R$ 10.000,00"},{id:3, text:"Acima de R$ 10.000,00"} ];

  constructor(private cadastroservice: CadastroService, private popupservice: PopupAlertService) { }

  ngOnInit() {
  }


  Finalizar(){
    this.cadastroservice.EnviarFormulario(this.formulario).then((retorno)=>{
      this.popupservice.showSucessMessage("Obrigado!","Em breve entraremos em contato com você!");
    });
  }
}
